import { render, staticRenderFns } from "./ComponentModal.vue?vue&type=template&id=64bbe0f8&"
import script from "./ComponentModal.vue?vue&type=script&lang=js&"
export * from "./ComponentModal.vue?vue&type=script&lang=js&"
import style0 from "./ComponentModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports